module.exports = __webpack_public_path__ + "img/livescan.fbe0c426.jpg";